import AccessGroupApartmentRemoveModal from './AccessGroupApartmentRemoveModal';

export default AccessGroupApartmentRemoveModal;
